/* unplugin-vue-components disabled */import { render } from "./app.vue?vue&type=template&id=071db11c"
const script = {}

import exportComponent from "/Users/sujunyang/Desktop/company/newest-project/canary-web/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.5.14_vue@3.5.14_typescript@4.5.5__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__